<div class="campaign-metrics-container">
    <div class="metric-card" *ngFor="let metric of metrics; trackBy: trackByIndex" [style.background]="metric.gradient">
    <div class="card-content">
      <div class="card-header">
        <div class="title-section">
          <span class="metric-title">{{ metric.title }}</span>
          <svg *ngIf="metric.tooltip" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"
            [matTooltip]="metric.tooltip">
            <circle cx="7" cy="7" r="6" stroke="currentColor" stroke-width="1.17"/>
            <path d="M7 4.5V7M7 9.5H7.01" stroke="currentColor" stroke-width="1.17" stroke-linecap="round"/>
          </svg>
        </div>
      </div>
      
      <div class="card-body">
        <div class="values-row">
          <div class="primary-value">{{ displayValue(metric.primaryValue) }}</div>
          <div class="secondary-value">{{ displayValue(metric.secondaryValue) }}</div>
        </div>
        
        <div class="labels-row">
          <div class="label-section">
            <div class="label-with-change" *ngIf="metric.primaryChange">
              <span class="change-value">{{ metric.primaryChange }}</span>
              <span class="label-text">{{ metric.primaryLabel }}</span>
            </div>
            <div class="label-only" *ngIf="!metric.primaryChange">
              <span class="label-text">{{ metric.primaryLabel }}</span>
            </div>
          </div>
          
          <div class="label-section flex-end">
            <div class="label-with-change" *ngIf="metric.secondaryChange">
              <span class="change-value">{{ metric.secondaryChange }}</span>
              <span class="label-text">{{ metric.secondaryLabel }}</span>
            </div>
            <div class="label-only" *ngIf="!metric.secondaryChange">
              <span class="label-text">{{ metric.secondaryLabel }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
